/**
 * @file useProcessState.hook.ts
 * @path apps/website/src/features/recruitment/hooks/useProcessState.hook.ts
 */
import { useState, useMemo } from "react";
import { RecruitmentStep } from "../recruitment.types";
import { video2, video3, video4, video5, video6 } from "@/assets/videos";

// Hardcoded data moved out of the component
const recruitmentSteps: RecruitmentStep[] = [
  {
    id: "01",
    title: "Submit Your Application",
    description:
      "Ready to get on the road? Send us your CV, valid driver's license, and PrDP. We're looking for safe, reliable drivers.",
    media: { type: "video", src: video2 },
  },
  {
    id: "02",
    title: "Initial Screening Call",
    description:
      "Our hiring manager will schedule a brief call to verify documents and discuss your professional driving history.",
    media: { type: "video", src: video3 },
  },
  {
    id: "03",
    title: "In-Person Interview",
    description:
      "Meet our Fleet Manager to discuss local route knowledge and how you align with our high service standards.",
    media: { type: "video", src: video4 },
  },
  {
    id: "04",
    title: "Practical Driving Assessment",
    description:
      "Complete a driving assessment with a senior driver to evaluate safety awareness and ride smoothness.",
    media: { type: "video", src: video5 },
  },
  {
    id: "05",
    title: "Welcome Aboard!",
    description:
      "Congratulations! If you've passed, we'll extend an offer. Welcome to the Sir Bastian's family fleet.",
    media: { type: "video", src: video6 },
  },
];

export const useProcessState = () => {
  const [activeStepId, setActiveStepId] = useState(recruitmentSteps[0].id);
  const activeStep = useMemo(
    () => recruitmentSteps.find((s) => s.id === activeStepId)!,
    [activeStepId],
  );

  return { steps: recruitmentSteps, activeStepId, activeStep, setActiveStepId };
};
